


























import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "transaction.investor.occupancyRate",
            specificId: uuidv4() as string,
            inputName: "investment-property-percentage-rented"
        };
    },
    computed: {
        percentageRented: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            let isDisplayed: boolean = this.$store.getters["FormModule/getValue"]("transaction.investor.isInvestmentProperty") === true;
            if (!isDisplayed) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
            return isDisplayed;
        }
    },
    methods: {
        updatePercentageRented: function(percentageRented: number): void {
            if (percentageRented == 0 && this.percentageRented != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": percentageRented});
            }
        }
    }
});

